import { DefaultTheme, ThemeProvider } from 'styled-components';
import { PropsWithChildren, useMemo } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { useBridgeState } from '@digitaz/bridge-sdk-client';
import { STORAGE_KEYS } from '@/constants/storageKeys';
import { defaultTheme } from '@/styles/defaultTheme';

interface IThemeProviderWrapper extends PropsWithChildren {
  isWebView: boolean;
}

export const ThemeProviderWrapper = (props: IThemeProviderWrapper) => {
  const [theme] = useLocalStorage<DefaultTheme>(
    STORAGE_KEYS.THEME,
    defaultTheme
  );

  let { tabBarHeight } = theme;
  const bridgeState = useBridgeState();
  const isWebView = props.isWebView || bridgeState.isWebView;
  const insetsBottom = bridgeState.insets?.bottom ?? 0;

  if (isWebView && bridgeState.insets) {
    tabBarHeight = theme.tabBarHeight + insetsBottom;
  }

  const themeValue = useMemo(
    () => ({ ...theme, isWebView, tabBarHeight, insetsBottom }),
    [theme, isWebView, tabBarHeight, insetsBottom]
  );

  return <ThemeProvider theme={themeValue}>{props.children}</ThemeProvider>;
};
